import { UkBets } from 'interfaces/bet-data';
import store from 'store';

export const getIsMultipleGeneralField = (betItem: UkBets) => {
  const allLsBetsCount: number = store.getState()?.betSlip.allLsBets.length;

  return (
    betItem.count === allLsBetsCount &&
    !betItem.strongCount &&
    betItem.type !== 1
  );
};
